<template>
  <div class="analog-line-beward">
    <div class="analog-line-beward__header">
      <v-icon color="primary" class="analog-line-beward__header-icon">mdi-phone-outline</v-icon>
      <h2 class="analog-line-beward__title">Аналоговая линия и настройка звука</h2>
    </div>
    <v-form ref="formSoundDoorphone" v-model="validSound" lazy-validation>
      <v-row class="analog-line-beward__form-row">
        <v-col cols="12" md="3" class="analog-line-beward__col-left">
          <h5 class="mb-3 analog-line-beward__subtitle">Режим работы звука</h5>
          <v-row no-gutters>
            <v-col cols="12" class="analog-line-beward__field-col">
              <v-text-field
                v-model="formSound.AHSSens"
                flat
                outlined
                dense
                type="number"
                label="Чувствительность микрофона"
                :rules="rules.Vol"
                prepend-inner-icon="mdi-microphone"
                class="analog-line-beward__field"
              />
            </v-col>
            <v-col cols="12" class="analog-line-beward__field-col">
              <v-text-field
                v-model="formSound.AHSVol"
                flat
                outlined
                dense
                type="number"
                label="Громкость динамика"
                :rules="rules.Vol"
                prepend-inner-icon="mdi-volume-high"
                class="analog-line-beward__field"
              />
            </v-col>
            <v-col cols="12" class="analog-line-beward__field-col">
              <v-text-field
                v-model="formSound.SystemVol"
                flat
                outlined
                dense
                type="number"
                label="Громкость системных звуков"
                :rules="rules.SystemVol"
                prepend-inner-icon="mdi-speaker"
                class="analog-line-beward__field"
              />
            </v-col>
            <v-col cols="12" class="analog-line-beward__field-col">
              <v-text-field
                v-model="formSound.AudioOutVol"
                flat
                outlined
                dense
                label="Мощность выхода"
                :rules="rules.audio"
                prepend-inner-icon="mdi-export"
                class="analog-line-beward__field"
              />
            </v-col>
            <v-col cols="12" class="analog-line-beward__field-col">
              <v-text-field
                v-model="formSound.AudioInVol"
                flat
                outlined
                dense
                label="Чувствительность входа"
                :rules="rules.audio"
                prepend-inner-icon="mdi-import"
                class="analog-line-beward__field"
              />
            </v-col>
            <v-col cols="12" class="analog-line-beward__field-col analog-line-beward__checkbox-col">
              <div class="analog-line-beward__checkbox-wrap">
                <v-icon left color="primary" small>mdi-waveform</v-icon>
                <v-checkbox
                  v-model="formSound.EchoCancellation"
                  :label="displayLabel(formSound.EchoCancellation)"
                  class="mt-0 analog-line-beward__checkbox"
                  hide-details
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" class="analog-line-beward__col-cards">
          <v-row>
            <v-col cols="12" md="6" class="analog-line-beward__card-col">
              <v-card class="analog-line-beward__card">
              <h5 class="mb-3 pa-2 analog-line-beward__subtitle">Режимы уровня напряжения</h5>
              <v-row class="pl-2 pr-2">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="handsetUpLevel"
                    flat
                    outlined
                    dense
                    type="number"
                    label="Уровень снятия трубки"
                    prepend-inner-icon="mdi-phone-hangup"
                    class="analog-line-beward__field"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="doorOpenLevel"
                    flat
                    outlined
                    dense
                    type="number"
                    label="Уровень открытия двери"
                    prepend-inner-icon="mdi-door-open"
                    class="analog-line-beward__field"
                  />
                </v-col>
              </v-row>
            <v-card-actions class="text-right pl-4 pr-4 pb-4" style="display: block;">
              <v-btn
                color="primary"
                outlined
                rounded
                class="text-none mt-0"
                :loading="isLoadingAnalogLine"
                @click.prevent="updateAnalogLine"
              >
                <v-icon left small>mdi-content-save-outline</v-icon>
                Сохранить
              </v-btn>
            </v-card-actions>
            </v-card>
            </v-col>
            <v-col cols="12" md="6" class="analog-line-beward__card-col">
              <v-card class="analog-line-beward__card">
              <v-col class="pb-0">
                <h5 class="pb-2 analog-line-beward__subtitle">Измерение аналоговой линии</h5>
                <v-text-field
                  v-model="numberAbonent"
                  flat
                  outlined
                  dense
                  type="number"
                  label="Номер квартиры"
                  required
                  prepend-inner-icon="mdi-home"
                  class="analog-line-beward__field"
                />
              </v-col>
              <div class="pl-4">
                <p v-if="doorphone">
                  Нумерация квартир: {{ doorphone.diapason_from }} - {{ doorphone.diapason_to }}.
                </p>
              </div>
              <div class="pl-4">
                <p v-if="voltage">
                    Результат: {{ voltage }}
                  <v-icon color="primary" class="ml-1 mb-1" v-if="!isIconUpdate" @click="measurementVoltage">
                    mdi-update
                  </v-icon>
                </p>
              </div>
              <v-card-actions class="text-right" style="display: block;">
                <v-btn
                  color="primary"
                  outlined
                  rounded
                  class="ml-auto ma-2 text-none mt-0"
                  :loading="loading"
                  :disabled="!numberAbonent"
                  @click.prevent="measurementVoltage"
                >
                  <v-icon left small>mdi-speedometer</v-icon>
                  Измерить
                </v-btn>
              </v-card-actions>
            </v-card>
            </v-col>
          </v-row>
          <div class="analog-line-beward__steps">
            <h5 class="analog-line-beward__subtitle mb-2">Укажите уровни напряжения, выполнив следующие шаги:</h5>
            <div class="analog-line-beward__steps-text"><span v-html="
      '<br><span class=&quot;step-title&quot;>Шаг 1:</span> Измерьте аналоговую линию введя номер квартиры. Убедитесь, что трубка квартиры не снята, и нажмите ' +
      'кнопку «Измерить». Появится результат <span class=&quot;example-number&quot;>(например, 250)</span>. Запомните или запишите это число.<br><br>' +
      '<span class=&quot;step-title&quot;>Шаг 2:</span> Снимите трубку квартиры и нажмите кнопку «Измерить». Появится результат ' +
      '<span class=&quot;example-number&quot;>(например, 450)</span>. «Уровень снятия трубки» вычисляется по формуле <span class=&quot;formula&quot;>(450-250)/2+250</span>.<br><br>' +
      '<span class=&quot;step-title&quot;>Шаг 3:</span> Зажмите и не отпускайте кнопку открытия двери на трубке. Нажмите кнопку ' +
      '«Измерить». Появится результат <span class=&quot;example-number&quot;>(например, 650)</span>. Отнимите от этого числа 50 и занесите ' +
      'результат в поле «Уровень открытия двери».'
    ">
    </span></div>
          </div>
        </v-col>
      </v-row>
      <div class="analog-line-beward__actions">
        <v-btn
          color="primary"
          class="text-none"
          rounded
          :disabled="!validSound"
          @click="validateSoundSettings()"
        >
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn
          color="primary"
          outlined
          rounded
          class="text-none ml-2"
          @click.prevent="returnDoorphone()"
        >
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import { ECHO_CANCELLATION, rules } from '../../../consts';

export default {
  name: 'SoundSetup',
  props: {
    doorphone: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      validSound: true,
      rules,
      formSound: {
        EchoCancellation: null,
        AudioOutVol: '',
        AudioInVol: '',
        SystemVol: '',
        AHSVol: '',
        AHSSens: '',
      },
      numberAbonent: null,
      handsetUpLevel: null,
      doorOpenLevel: null,
      loading: false,
      isLoadingAnalogLine: false,
      isIconUpdate: false,
      voltage: '',
    };
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
  },
  methods: {
    ...mapActions({
      getSoundSettingsBeward: 'Doorphone/getSoundSettingsBeward',
      updateSoundSettingsBeward: 'Doorphone/updateSoundSettingsBeward',
      getAnalogLineBeward: 'Doorphone/getAnalogLineBeward',
      checkAnalogLineBeward: 'Doorphone/checkAnalogLineBeward',
      updateAnalogLineBeward: 'Doorphone/updateAnalogLineBeward',
    }),
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    displayLabel (item) {
      return ECHO_CANCELLATION[item];
    },
    async updateAnalogLine () {
      try {
        this.isLoadingAnalogLine = true;
        if (this.handsetUpLevel === '' || this.doorOpenLevel === '') {
          this.$flash_danger('Укажите данные');
          return;
        }
        const data = {
          handset_up_level: this.handsetUpLevel,
          door_open_level: this.doorOpenLevel,
        };
        await this.updateAnalogLineBeward({
          id: this.$route.params.id,
          data: data,
        });
        this.$flash_success('Уровни напряжения успешно обновились!');
      } catch (e) {
        console.error(e);
        this.$flash_warning('Не удалось обновить уровни напряжения');
      } finally {
        this.isLoadingAnalogLine = false;
      }
    },
    async measurementVoltage () {
      try {
        this.loading = true;
        this.isIconUpdate = true;
        this.isStopAnalogLine = true;
        const data = await this.checkAnalogLineBeward({
          id: this.$route.params.id,
          number: this.numberAbonent,
        });
        this.voltage = data.message;
        this.$flash_success('Успешно!');
      } catch (error) {
        console.error(error);
        this.$flash_warning('Не удалось измерить аналоговую линию');
      } finally {
        this.loading = false;
        this.isIconUpdate = false;
      }
    },
    validateSoundSettings () {
      if (this.$refs.formSoundDoorphone.validate()) {
        const dataSound = {
          EchoCancellation: this.formSound.EchoCancellation,
          AudioOutVol: this.formSound.AudioOutVol,
          AudioInVol: this.formSound.AudioInVol,
          SystemVol: this.formSound.SystemVol,
          AHSVol: this.formSound.AHSVol,
          AHSSens: this.formSound.AHSSens,
        };
        this.updateSoundSettingsBeward({
          id: this.$route.params.id,
          settings: dataSound,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене настроек звука');
          });
      } else {
        this.$flash_warning('Заполните все поля');
      }
    },
  },
  created () {
    this.getAnalogLineBeward(this.$route.params.id)
      .then((res) => {
        this.handsetUpLevel = res.handset_up_level;
        this.doorOpenLevel = res.door_open_level;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке настроек уровня напряжения.');
      });
    this.getSoundSettingsBeward(this.$route.params.id)
      .then((res) => {
        this.formSound = res;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке настроек звука.');
      });
  },

};
</script>
<style lang="scss" scoped>
.analog-line-beward__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.analog-line-beward__header-icon {
  flex-shrink: 0;
}

.analog-line-beward__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.analog-line-beward__form-row {
  align-items: flex-start;
}

.analog-line-beward__col-left {
  padding-top: 4px;
}

.analog-line-beward__field-col {
  padding-top: 12px !important;
  padding-bottom: 0 !important;
}

.analog-line-beward__field-col:first-child {
  padding-top: 8px !important;
}

.analog-line-beward__checkbox-col {
  padding-left: 12px !important;
}

.analog-line-beward__col-cards {
  padding-top: 4px;
}

.analog-line-beward__card-col {
  margin-bottom: 16px;
}

.analog-line-beward__steps {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.analog-line-beward__steps-text {
  font-size: 0.9375rem;
  line-height: 1.5;
  color: #546e7a;
}

.analog-line-beward__subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #546e7a;
}

.analog-line-beward__card {
  border-radius: 16px;
  height: 100%;
}

.analog-line-beward__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.analog-line-beward__checkbox-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.analog-line-beward__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 32px;
}
</style>

<style lang="scss">
.step-title {
  color: #1976D2;
  font-weight: bold;
}
.example-number {
  color: #388E3C;
  font-style: italic;
}
.formula {
  color: #D32F2F;
  font-weight: bold;
}
</style>
